/**
 * Lightweight campaign/action label maps shared across features.
 *
 * These are pure data constants — no dependencies — extracted so consumers
 * don't have to pull in the full audit-logs feature just for display labels.
 */

/**
 * Action type labels
 * Maps backend action type values to user-friendly display names.
 */
export const ActionTypeLabels: Record<string | number, string> = {
  // Delays (group: 'delays')
  conditional_wait_action: 'Wait Until…',
  delay_seconds_action: 'Time Delay',
  delay_time_window_action: 'Time Window',
  grace_period_action: 'Grace Period',
  randomized_delay_action: 'Randomized Delay',
  // Messages (group: 'messages')
  email_action: 'Email',
  slack_action: 'Slack Message',
  twilio_action: 'SMS',
  whatsapp_action: 'WhatsApp',
  line_action: 'LINE Message',
  push_action: 'Push Notification',
  in_app_action: 'In-App Message',
  urban_airship_action: 'Airship',
  // Data (group: 'data')
  webhook_action: 'Webhook',
  attribute_update_action: 'Create or Update Person',
  static_seg_update_action: 'Manual Segment Update',
  collection_query_action: 'Query Collection',
  create_event_action: 'Send Event',
  batch_update_action: 'Batch Update',
  llm_action: 'Run LLM',
  // Tests & Branches (group: 'flow_control')
  split_randomized_action: 'A/B Test',
  conditional_branch_action: 'True/False Branch',
  multi_split_branch_action: 'Multi-Split Branch',
  multi_lang_branch_action: 'Multi-Language Branch',
  random_cohort_branch_action: 'Random Cohort Branch',
  filter_match_delay_action: 'Filter Match Delay',
  exit_action: 'Exit',

  // Numeric ActionType values from services/campaigns/configuration.proto
  0: 'Email',
  1: 'Time Delay',
  2: 'Time Window',
  3: 'A/B Test',
  4: 'Webhook',
  5: 'SMS',
  6: 'Airship',
  7: 'Slack Message',
  8: 'Create or Update Person',
  9: 'Filter Match Delay',
  10: 'Push Notification',
  // 11 is deprecated (was SplitAttr)
  12: 'Wait Until…',
  13: 'True/False Branch',
  14: 'Multi-Split Branch',
  15: 'Exit',
  16: 'Random Cohort Branch',
  17: 'Manual Segment Update',
  18: 'Query Collection',
  19: 'Send Event',
  20: 'Multi-Language Branch',
  21: 'Batch Update',
  22: 'In-App Message',
  23: 'Trigger',
  24: 'Global Exit',
  25: 'LINE Message',
  26: 'Run LLM',
  27: 'WhatsApp',
  28: 'Randomized Delay',
};

/**
 * Campaign state labels
 * Maps backend campaign state values to user-friendly display names.
 */
export const CampaignStateLabels: Record<string, string> = {
  running: 'Running',
  draft: 'Draft',
  stopped: 'Stopped',
  archived: 'Archived',
  sunsetting: 'Stopping',
  stopping: 'Stopping',
  archiving: 'Archiving',
  unarchiving: 'Unarchiving',
};
